export const deepCopy = <T extends object>(target: T): T => {
  return structuredClone(target)
}
